import PropTypes from 'prop-types';
import { List, ListItem, ListItemText, Paper, Popper } from '@mui/material';

import { WORDCLOUD_TOOLTIP_VERSION_HEIGHT } from 'constants/wordcloud';

const styles = {
  tooltip: ({ palette, spacing }) => ({
    padding: spacing(1, 3),
    backgroundColor: palette.text.primary,
    borderRadius: 2.5,
  }),
  tooltipItem: {
    height: WORDCLOUD_TOOLTIP_VERSION_HEIGHT,
    marginBottom: 1,
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  tooltipText: {
    margin: 'unset',
  },
};

export const WordCloudTooltip = ({ versions = [], anchorEl = null }) => {
  if (!versions?.length || !anchorEl) {
    return null;
  }

  return (
    <Popper open disablePortal anchorEl={anchorEl} placement="right-end" role="tooltip" aria-live="polite">
      <Paper elevation={0} sx={styles.tooltip}>
        <List disablePadding>
          {versions.map((version) => (
            <ListItem key={version} disablePadding disableGutters sx={styles.tooltipItem}>
              <ListItemText
                primary={version}
                primaryTypographyProps={{
                  variant: 'button',
                  color: 'text.secondary',
                  sx: styles.tooltipText,
                }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Popper>
  );
};

WordCloudTooltip.propTypes = {
  versions: PropTypes.arrayOf(PropTypes.string),
  anchorEl: PropTypes.shape({}),
};
